/*
 *
 * Groups constants
 *
 */
export var LOAD_GROUPS_REQUEST = 'app/Groups/LOAD_GROUPS_REQUEST';
export var LOAD_GROUPS_SUCCESS = 'app/Groups/LOAD_GROUPS_SUCCESS';
export var LOAD_GROUPS_FAILURE = 'app/Groups/LOAD_GROUPS_FAILURE';
export var UPDATE_GROUPS_REQUEST = 'app/Groups/UDPATE_GROUPS_REQUEST';
export var UPDATE_GROUPS_SUCCESS = 'app/Groups/UPDATE_GROUPS_SUCCESS';
export var UPDATE_GROUPS_FAILURE = 'app/Groups/UPDATE_GROUPS_FAILURE';
export var DELETE_GROUP_REQUEST = 'app/Groups/DELETE_GROUP_REQUEST';
export var DELETE_GROUP_SUCCESS = 'app/Groups/DELETE_GROUP_SUCCESS';
export var DELETE_GROUP_FAILURE = 'app/Groups/DELETE_GROUP_FAILURE';
